import { render, staticRenderFns } from "./SeleccionarAsientosMapaGeneral.vue?vue&type=template&id=1b2d7e55"
import script from "./SeleccionarAsientosMapaGeneral.vue?vue&type=script&lang=js"
export * from "./SeleccionarAsientosMapaGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports